import Helper from '@ember/component/helper'
import { service } from '@ember/service'
import { isUnsupportedStandardsSet } from 'district-ui-client/components/standards-set/unsupported-alert'
import type ReportingService from 'district-ui-client/services/reporting'
import type SessionService from 'district-ui-client/services/session'

interface Signature {
  Args: {
    Positional: unknown[]
    Named: object
  }
  Return: boolean
}

export class currentStandardsSetUnsupported extends Helper<Signature> {
  @service session!: SessionService
  @service reporting!: ReportingService

  compute(_positional: Signature['Args']['Positional'], _named: Signature['Args']['Named']) {
    const standardsSet = this.session.currentDistrict.standardsSet
    const product = this.reporting.product
    if (standardsSet && product) {
      return isUnsupportedStandardsSet(standardsSet, product)
    }
    return false
  }
}

export default currentStandardsSetUnsupported
